import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "KES") {
  const symbols = {
    KES: "KSh",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  const symbol = symbols[currency] || currency;
  const safeAmount = amount ?? 0;
  return `${symbol} ${safeAmount.toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("en-KE", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function generateOrderNumber() {
  const now = new Date();
  const timestamp = now.toISOString().replace(/[-:T.Z]/g, "").slice(0, 14);
  const random = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `ORD-${timestamp}-${random}`;
}

/**
 * Resolve an image URL to a full URL
 * - If it's a relative path (starts with /uploads/), prepend the backend URL with /api prefix
 * - If it's an absolute URL pointing to an old preview domain, update it
 * - Otherwise return as-is (external URLs like Unsplash)
 */
export function resolveImageUrl(imageUrl) {
  if (!imageUrl) return "";
  
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  
  // If it's a relative path starting with /uploads/, use /api/uploads for ingress routing
  if (imageUrl.startsWith("/uploads/")) {
    return `${backendUrl}/api${imageUrl}`;
  }
  
  // If it's already /api/uploads, just prepend backend URL
  if (imageUrl.startsWith("/api/uploads/")) {
    return `${backendUrl}${imageUrl}`;
  }
  
  // If it's a static file path
  if (imageUrl.startsWith("/static/")) {
    return `${backendUrl}/api${imageUrl}`;
  }
  
  // If it's pointing to an old preview domain with /uploads/, fix it
  if (imageUrl.includes(".preview.emergentagent.com/uploads/")) {
    // Extract the relative path and use current backend URL with /api prefix
    const uploadPath = imageUrl.substring(imageUrl.indexOf("/uploads/"));
    return `${backendUrl}/api${uploadPath}`;
  }
  
  // Return as-is for external URLs (Unsplash, etc.)
  return imageUrl;
}

